/**
 *
 * @module accessToken
 *
 */

/**
 *
 * @class AccessToken
 * @desc Provides the interface used to exchange tokens to provide access to service requests.
 *
 */
export default class AccessToken {

    /**
     *
     * @param {String} token
     *
     */
    constructor(token) {

        /**
         *
         * @access public
         * @param {String} token
         * @desc The access token issued by the authorization server.
         *
         */
        this.token = token;

    }

}



// WEBPACK FOOTER //
// ./src/services/token/accessToken.js